// What a client company's own people did (routes/admin/activity.ts on the API).
import api from './client';

export interface ActivityRow {
  id: number;
  ts: number;
  admin_id: string | null;
  admin_email: string | null;
  method: string;
  path: string;
  status: number | null;
  action: string | null;
  entity_type: string | null;
  entity_id: string | null;
  app_id: string | null;
  app_name: string | null;
}

export const listActivity = (params: { page?: number; search?: string }) => {
  const qs = new URLSearchParams();
  if (params.page) qs.set('page', String(params.page));
  if (params.search) qs.set('search', params.search);
  return api.get<{ rows: ActivityRow[]; total: number; page: number; limit: number }>(`/admin/activity?${qs.toString()}`);
};
